import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStepForwards = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16.375 3.64771L19.9357 7.20837L16.375 10.769L15.3144 9.70837L17.0644 7.95837H10.125C7.66275 7.95837 5.66669 9.95443 5.66669 12.4167C5.66669 14.879 7.66275 16.875 10.125 16.875H17.9584V18.375H10.125C6.83433 18.375 4.16669 15.7074 4.16669 12.4167C4.16669 9.126 6.83432 6.45837 10.125 6.45837H17.0644L15.3144 4.70837L16.375 3.64771Z",
		fill: "currentColor"
	})]
});
export default SvgStepForwards;
